/**
 * Image URL utility functions
 * Constructs image URLs using the API server
 */

const getApiBaseUrl = () => {
  // Get API base URL from environment variable
  let apiBase = process.env.REACT_APP_API_URL;
  
  if (apiBase) {
    // Ensure it's HTTP, not HTTPS
    apiBase = apiBase.replace(/^https:/i, 'http:');
    // Remove /api from the end if present
    return apiBase.replace(/\/api\/?$/, '');
  }
  
  // Default to api.guyrules.wpsee.com with HTTP
  return 'http://api.guyrules.wpsee.com';
};

export const getImageUrl = (imagePath) => {
  const baseUrl = getApiBaseUrl();
  
  // Ensure path starts with /
  const path = imagePath.startsWith('/') ? imagePath : '/' + imagePath;
  
  // Construct full URL
  const fullUrl = `${baseUrl}${path}`;
  
  // Ensure HTTP (not HTTPS) and remove double slashes (except after http://)
  return fullUrl.replace(/^https:/i, 'http:').replace(/([^:]\/)\/+/g, '$1');
};

export const getCategoryIconUrl = (iconName) => {
  if (!iconName) return '';
  
  // If it's already a full URL, convert HTTPS to HTTP
  if (iconName.startsWith('http')) {
    return iconName.replace(/^https:/i, 'http:');
  }
  
  // Normalize the path - remove leading/trailing slashes and check if it already contains 'images'
  let normalized = iconName.trim();
  
  // Remove leading slash for processing
  if (normalized.startsWith('/')) {
    normalized = normalized.substring(1);
  }
  
  // Check if path already contains 'images' directory
  // Handle cases like: 'images/buds2on.gif', '/images/buds2on.gif', 'buds2on.gif'
  if (normalized.startsWith('images/') || normalized.startsWith('images\\')) {
    // Already has images/ prefix, use it directly
    return getImageUrl(`/${normalized}`);
  } else {
    // No images/ prefix, add it
    return getImageUrl(`/images/${normalized}`);
  }
};
